import { registerPlugin } from '@capacitor/core';
const SumsubMobileSdk = registerPlugin('SumsubMobileSdk', {
    web: () => import('./web').then((m) => new m.SumsubMobileSdkWeb()),
});
export * from './definitions';
export { SumsubMobileSdk };
//# sourceMappingURL=index.js.map